module.exports = __webpack_public_path__ + "static/media/banner_slider.ef8b1841.jpeg";